var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocuments(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\t.statdoc_s0 { fill: #a8a0ef } \n\t")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-workspace-stat-documents"
  }, /*#__PURE__*/React.createElement("path", {
    id: "icon-workspace-stat-documents-path",
    fillRule: "evenodd",
    className: "statdoc_s0",
    d: "m16 7v12c0 1.1-0.9 2-2 2h-12c-1.1 0-2-0.9-2-2v-16c0-1.1 0.9-2 2-2h8zm-4 8h-8v2h8zm0-4h-8v2h8zm2.5-3l-5.5-5.5v5.5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocuments);
export default __webpack_public_path__ + "static/media/documents.33bc4d61544e94b8b4d133c703424503.svg";
export { ForwardRef as ReactComponent };